export const getFomatUrl = (url, size) => {
  if (url.startsWith('http://image.test.laodao.so') || url.startsWith('https://image.test.laodao.so') || url.startsWith('https://image.laodao.so') || url.startsWith('http://image.laodao.so')) {
    if (!url.endsWith('/format,png')) {
      return url + '?x-oss-process=image/resize,w_' + size + ',limit_0/format,webp'
    }
  }
  return url
}
